export default __webpack_public_path__ + "static/media/item_2@2x.9f1b0199.png";